import { getActiveUnitSet } from "@/store/project/selector"
import { useCallback } from "react"
import { useSelector } from "react-redux"


export const useGetUnitEntity = () => {
  const unitSet = useSelector(getActiveUnitSet)

  return useCallback((dimCode: string | undefined) => {
    if (!(unitSet && dimCode)){
      return;
    }
    return unitSet.units.find(item => item.dimcode === dimCode)
  }, [unitSet])
}